import { useSelector } from "@grandvisionhq/state";
import { isDefined } from "@grandvisionhq/utils";
import { usePrivateSteppingContext } from "../../Context/Context/PrivateSteppingContext.js";
import { getStepsList, getCurrentStepIndex, getCurrentStepName } from "../../state/state/selectors.internal.js";
const useSteps = () => {
  const { configuratorId, stepsMap, selectorProps } = usePrivateSteppingContext();
  const steps = useSelector(
    (s) => getStepsList(s, selectorProps)
  );
  const currentStepIndex = useSelector(
    (s) => getCurrentStepIndex(s, selectorProps)
  );
  const currentStepName = useSelector(
    (s) => getCurrentStepName(s, selectorProps)
  );
  if (!isDefined(currentStepName)) {
    throw new Error(`currentStepName must be defined. However, "${currentStepName}" was received.`);
  }
  const currentStep = stepsMap[currentStepName];
  if (!isDefined(currentStep)) {
    throw new Error(`currentStep must be defined. However, "${currentStep}" was received.`);
  }
  return { configuratorId, steps, currentStepIndex, currentStep, currentStepName };
};
export {
  useSteps
};
//# sourceMappingURL=use-steps.js.map
